import React, { useState } from 'react';
import api from './api';

// Changement de son propre mot de passe. Deux usages :
// - obligatoire : juste après la connexion, quand un administrateur a fixé le
//   mot de passe (création du compte, réinitialisation). Rien d'autre n'est
//   accessible tant qu'il n'est pas remplacé — le serveur le refuse aussi ;
// - libre : page « Mon mot de passe », à tout moment.
export default function MotDePasse({ obligatoire = false, onTermine, onDeconnecter }) {
  const [actuel, setActuel] = useState('');
  const [nouveau, setNouveau] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreur, setErreur] = useState('');
  const [info, setInfo] = useState('');
  const [envoi, setEnvoi] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault(); setErreur(''); setInfo('');
    if (nouveau !== confirmation) { setErreur('Les deux saisies du nouveau mot de passe ne sont pas identiques.'); return; }
    setEnvoi(true);
    try {
      await api.post('/auth/mot-de-passe', { actuel, nouveau });
      setActuel(''); setNouveau(''); setConfirmation('');
      if (obligatoire) onTermine?.();
      else setInfo('Mot de passe changé.');
    } catch (err) {
      setErreur(err.response?.data?.error || 'Changement impossible.');
    } finally { setEnvoi(false); }
  };

  const champs = (
    <>
      <label htmlFor="mdp-actuel">{obligatoire ? 'Mot de passe reçu' : 'Mot de passe actuel'}</label>
      <input id="mdp-actuel" type="password" value={actuel} onChange={(e) => setActuel(e.target.value)} autoComplete="current-password" autoFocus={obligatoire} />
      <label htmlFor="mdp-nouveau">Nouveau mot de passe <span className="discret">(10 caractères minimum)</span></label>
      <input id="mdp-nouveau" type="password" value={nouveau} onChange={(e) => setNouveau(e.target.value)} autoComplete="new-password" minLength={10} />
      <label htmlFor="mdp-confirmation">Nouveau mot de passe, à nouveau</label>
      <input id="mdp-confirmation" type="password" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} autoComplete="new-password" />
      {erreur && <div className="erreur">{erreur}</div>}
      {info && <div className="bandeau-info">{info}</div>}
      <button type="submit" disabled={envoi || !actuel || nouveau.length < 10 || !confirmation}>
        {envoi ? 'Enregistrement…' : 'Enregistrer le nouveau mot de passe'}
      </button>
    </>
  );

  if (obligatoire) {
    return (
      <div className="connexion">
        <form className="carte" onSubmit={soumettre}>
          <h1 className="logotype" aria-label="A97 VIN"><span className="a">A</span><span className="n">97</span><span className="app">VIN</span></h1>
          <p className="mdp-explication">
            Votre mot de passe a été choisi par un administrateur. Remplacez-le par un mot de passe
            personnel, connu de vous uniquement, pour accéder à l’application.
          </p>
          {champs}
          <button type="button" className="lien" onClick={onDeconnecter}>Se déconnecter</button>
        </form>
      </div>
    );
  }

  return (
    <div className="page-mdp">
      <h1>Mon mot de passe</h1>
      <form className="carte mdp-formulaire" onSubmit={soumettre}>{champs}</form>
    </div>
  );
}
